// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"545e3329","225":"d21588ad","358":"ee774546","611":"99637db2","639":"579883e7","652":"7f2516d9","659":"57477112","853":"1c6174ba","948":"8fc71279"}[chunkId] + ".chunk.js";
};